/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  hasDoneActivitiesByMonthStackedBarChartAccess,
  hasLawsuitCounterAccess,
  hasLawsuitUpdatesCounterAccess,
} from "./selectors/powersSelectors";
// import { sendEventTabOpen } from "services/dashboard-module/dashboardAnalyticEventService";
import { dashboardTabSubTypes } from "./utils/constants/dashboard/analyticDashboardEvents";

import DoneActivitiesByMonthStackedBarChart from "./charts/calendar/DoneActivitiesByMonthStackedBarChart";
import LawsuitCounter from "./charts/lawsuit/LawsuitCounter";
import LawsuitUpdatesCounter from "./charts/lawsuit/LawsuitUpdatesCounter";
import { ChartSectionWrapper, DashboardCol, TabWrapper } from "./style";

const DashboardSingleSection = () => {
  const shouldRender = {
    doneActivitiesByMonthStackedBarChart: useSelector(
      hasDoneActivitiesByMonthStackedBarChartAccess
    ),
    lawsuitUpdatesCounter: useSelector(hasLawsuitUpdatesCounterAccess),
    lawsuitCounter: useSelector(hasLawsuitCounterAccess),
  };

  // useEffect(() => {
  //   sendEventTabOpen(dashboardTabSubTypes.UP_SMART);
  // }, []);

  return (
    <TabWrapper>
      <ChartSectionWrapper>
        {shouldRender.lawsuitUpdatesCounter && (
          <DashboardCol xs={12} sm={12} md={12} lg={6}>
            <LawsuitUpdatesCounter />
          </DashboardCol>
        )}
        {shouldRender.lawsuitCounter && (
          <DashboardCol xs={12} sm={12} md={12} lg={6}>
            <LawsuitCounter />
          </DashboardCol>
        )}
        {shouldRender.doneActivitiesByMonthStackedBarChart && (
          <DashboardCol xs={12} sm={12} md={12} lg={12}>
            <DoneActivitiesByMonthStackedBarChart />
          </DashboardCol>
        )}
      </ChartSectionWrapper>
    </TabWrapper>
  );
};

export default DashboardSingleSection;
